import { config, handleResponse } from '../../_helpers';

export const croAccountingServices = {
    // GET
    getVoyageListingForCroAccounting,
    getWayBIllListForCROAccounting,
    getWayBIllCROAccounting,
    getCroId,
    getVoyageDestination,

    // POST 
    createCroAccounting,
    generateWaybillInvoice,
    postCROAccounting,
    postCROToBase,

    // PUT
    updateCROAccounting,
    updateCROAccountingStatus,

    // DELETE
    deleteCroAccounting,

    // PDC Clearing
    loadPdcCollection,
    clearPdcCollection,

    // BASE Manual SI
    manualSalesInvoice,
}

function getVoyageListingForCroAccounting(search) {
    const requestOptions = {
        method: 'GET'
    };
    
    // if(search){
    //     return fetch(`${config.apiUrl}/CroAccountings/getVoyageListingForCroAccounting?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/CroAccountings/getVoyageListingForCroAccounting`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/CroAccountings/getVoyageListingForCroAccountingV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/CroAccountings/getVoyageListingForCroAccountingV1`, requestOptions).then(handleResponse);
    }
}

function getWayBIllListForCROAccounting(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CroAccountings/getWayBIllListForCROAccounting/${voyageNum}`, requestOptions).then(handleResponse);
}

function getWayBIllCROAccounting(waybillRef) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CroAccountings/getWayBIllCROAccounting/${waybillRef}`, requestOptions).then(handleResponse);
}

function getCroId(croId) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/CroAccountings/getCroId/${croId}`, requestOptions).then(handleResponse);
}

function createCroAccounting(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CroAccountings/createCroAccounting`, requestOptions).then(handleResponse);
}

function updateCROAccounting(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CroAccountings/updateCROAccounting/${id}`, requestOptions).then(handleResponse);
}

function updateCROAccountingStatus(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CroAccountings/updateCROAccountingStatus/${id}`, requestOptions).then(handleResponse);
}

function deleteCroAccounting(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CroAccountings/deleteCroAccounting`, requestOptions).then(handleResponse);
}

function getVoyageDestination(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/CroAccountings/getVoyageDestination/${voyageNum}`, requestOptions).then(handleResponse);
        return fetch(`${config.apiUrl}/CroAccountings/getVoyageDestinationWithVessel/${voyageNum}`, requestOptions).then(handleResponse);
}

function generateWaybillInvoice(voyageNum, payload, branchCodeId) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/CroAccountings/generateWaybillInvoiceV1/${voyageNum}?branhCode=${branchCodeId}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/CroAccountings/generateWaybillInvoiceV3/${voyageNum}?branhCode=${branchCodeId}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/CroAccountings/generateWaybillInvoice/${voyageNum}?branhCode=${branchCodeId}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/CroAccountings/generateWaybillInvoice1/${voyageNum}?branhCode=${branchCodeId}`, requestOptions).then(handleResponse);
}

function postCROAccounting(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/CroAccountings/postCROAccounting`, requestOptions).then(handleResponse);
}

function postCROToBase(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/CroAccountings/postCROToBase`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/CroAccountings/postCROToBaseV1`, requestOptions).then(handleResponse);
}

function loadPdcCollection(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/PdcClearing/loadPdcCollection`, requestOptions).then(handleResponse);
}

function clearPdcCollection(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/PdcClearing/clearPdcCollection`, requestOptions).then(handleResponse);
}

function manualSalesInvoice(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/BaseManualSI/manualSalesInvoice`, requestOptions).then(handleResponse);
}